<template>
    <div class="sk-spinner"></div>
</template>

<script>
    export default {
        name: 'Spinner'
    }
</script>

<style scoped>

    .sk-spinner:before {
        content: "";
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        border-radius: 50%;
        border: 2px solid #ccc;
        border-top-color: #333;
        -webkit-animation: spinner .6s linear infinite;
        animation: spinner .6s linear infinite;
    }

    @keyframes spinner{
        to{
            transform:rotate(1turn)}
        }

</style>